import styled from 'styled-components'
import { Text } from 'components/Text'

export const TableContainer = styled.table`
  border-spacing: 0;
`

export const TableHeaderContainer = styled.tr`
  padding: 1rem;
`

export const TableHeaderHead = styled.th`
  padding: 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  font-size: 1.125rem;
  line-height: 1.125rem;
  font-weight: 500;
  text-align: initial;
  &:first-of-type {
    border-top-left-radius: 10px;
    border-left: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  }
  &:last-of-type {
    border-top-right-radius: 10px;
    border-right: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  }
`

export const TableContentContainer = styled.tbody`
  /* margin: 0 0 4rem; */
`

export const TableItemContainer = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  &:hover {
    background-color: #f3f2ff;
  }
`

export const TableItemBody = styled.td<{ justify?: string }>`
  padding: 1.5rem;
  text-align: ${({ justify }) => (justify ? 'center' : 'left')};
`

export const TableFooterContainer = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const TablePaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const TablePaginationItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e3e4eb;
`
export const TablePaginationPage = styled.li<{ active: boolean }>`
  height: 100%;
  margin: 5px 15px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.secondary}, sans-serif;
  transition: all 0.25s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0px 10px;
  }
  ${({ active, theme }) =>
    active &&
    ` 
  padding: 0px 10px;
  background-color: ${theme.colors.white};
`}
`
export const TableCountContainer = styled.div``
export const TableCountText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`
